import { createSelector } from '@reduxjs/toolkit'
import { cartSlice } from '@/store/cartSlice'
import { servicesSlice } from '@/store/servicesSlice'
import { timeScheduleSlice } from '@/store/timeScheduleSlice'
import { serviceAmountSelector } from '@/store/timeScheduleSlice/selectors/serviceAmountSelector'
import { getBoughtServicesTotal } from '@/utils/timeSchedules'

export const selectTotalGlobalSelectedQuantity = createSelector(
  [
    servicesSlice.selectors.data,
    cartSlice.selectors.cartReservations,
    cartSlice.selectors.selectedElementReservation,
    timeScheduleSlice.selectors.service,
    serviceAmountSelector,
  ],
  (
    services,
    cartReservations,
    selectedElementReservation,
    selectedService,
    serviceAmount
  ) => {
    if (!services?.hasLimit) {
      return 0
    }

    const reservations = [
      ...(selectedElementReservation !== null
        ? [selectedElementReservation]
        : []),
      ...cartReservations.filter(
        (res) =>
          `${res.spotName}${res.spotType}` !==
          `${selectedElementReservation?.spotName}${selectedElementReservation?.spotType}`
      ),
    ]
    const ticketIds = services.ticketServices.map(
      (service) => service.serviceId
    )

    return (
      reservations.reduce((total, reservation) => {
        const isSelectedReservation = reservation === selectedElementReservation

        for (const key in reservation?.boughtServices) {
          const serviceId = Number(key)
          if (ticketIds.includes(serviceId)) {
            if (
              isSelectedReservation &&
              serviceId === selectedService?.serviceId
            ) {
              // NOOP: skip, use the serviceAmount instead
            } else {
              total += getBoughtServicesTotal(
                reservation.boughtServices[serviceId]
              )
            }
          }
        }

        return total
      }, 0) + (serviceAmount ?? 0)
    )
  }
)
